export const CAMPAIGN_LIST_REQUEST='CAMPAIGN_LIST_REQUEST'
export const CAMPAIGN_LIST_SUCCESS='CAMPAIGN_LIST_SUCCESS'
export const CAMPAIGN_LIST_FAIL='CAMPAIGN_LIST_FAIL'